/**
 * Image Fragment
 *
 * Common pattern for Sanity image objects used across multiple blocks.
 */

import { defineQuery } from 'next-sanity'

/**
 * Field projection for a Sanity image
 * Can be interpolated into block queries
 */
export const imageFields = `
  _type,
  asset,
  crop,
  hotspot,
  altText
`

/**
 * Complete query for a single image
 * Note: Images are typically embedded, not queried separately
 * This is mainly for type generation reference
 */
export const IMAGE_QUERY = defineQuery(/* groq */ `
  *[_type == "sanity.imageAsset"][0]{
    _id,
    url,
    metadata {
      dimensions,
      lqip
    }
  }
`)
